import * as React from 'react';
import { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Button, Text } from '@components/common';
import { WindowHeader, WindowLayout, WindowLayoutBody } from '@components/layouts/WindowLayout';
import { PublicAssetLogoSVG } from '@components/svgs';
import { track } from '@components/tracking';

import { api } from '../../api';

import { PublicDocument } from './PublicDocument';

export const InsightPage: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { slug } = useParams() as { slug: string };

  const { data: insight, isSuccess } = api.useGetInsightQuery({ slug });

  useEffect(() => {
    if (isSuccess) {
      track('viewed_insight', {
        layout: 'public',
        artifact_type: 'insight',
        is_creator: false,
        is_guest: true
      });
    }
  }, [isSuccess]);

  return (
    <WindowLayout>
      <WindowHeader>
        <a href='/'>
          <PublicAssetLogoSVG />
        </a>
        <div className='ml-auto flex space-x-4'>
          <Button link href='/users/sign_in'>
            Log in
          </Button>
          <Button primary href={`/users/sign_up?asset_referrer=${slug}`}>
            Sign up for free
          </Button>
        </div>
      </WindowHeader>
      <WindowLayoutBody className='h-full bg-white'>
        <Text h='700'>{insight?.title}</Text>
        {insight && <PublicDocument insight={insight} studyId={insight.project_id} />}
      </WindowLayoutBody>
    </WindowLayout>
  );
};
